import React from 'react';
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'dark' | 'ghost' | 'danger' | 'icon';
  size?: 'sm' | 'md' | 'lg' | 'icon';
}
export function Button({
  className,
  variant = 'primary',
  size = 'md',
  ...props
}: ButtonProps) {
  const variants = {
    // 1. Primary — brand gradient (both modes) — softer pink start
    primary: 'bg-gradient-to-r from-[#f0407a] to-[#a855f7] text-white font-semibold rounded-xl shadow-lg shadow-pink-500/25 hover:shadow-pink-500/35 hover:scale-[1.02] transition-all disabled:hover:scale-100',
    // 2. Secondary — white bordered (light) / slate (dark)
    secondary: 'jua-btn-secondary bg-white border border-slate-200 text-slate-700 font-semibold rounded-xl hover:bg-slate-50 hover:border-slate-300 transition-all',
    // 3. Dark — slate 900 (modal confirmations, create actions)
    dark: 'bg-slate-900 text-white font-semibold rounded-xl hover:bg-slate-800 transition-all',
    // 4. Ghost — text only
    ghost: 'bg-transparent text-slate-600 font-medium hover:text-slate-900 transition-colors rounded-lg',
    // 5. Destructive ghost
    danger: 'bg-transparent text-red-600 font-medium hover:text-red-700 hover:bg-red-50 rounded-lg transition-all',
    // 6. Icon / toolbar
    icon: 'p-2 rounded-lg text-slate-400 hover:text-slate-600 hover:bg-slate-100/60 transition-colors'
  };
  const sizes = {
    sm: 'h-8 px-3 text-xs',
    md: 'h-9 px-4 text-sm',
    lg: 'h-11 px-6 text-base',
    icon: 'h-9 w-9 p-2 flex items-center justify-center'
  };
  return <button className={cn('inline-flex items-center justify-center focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-pink-500 disabled:pointer-events-none disabled:opacity-50 disabled:cursor-not-allowed', variants[variant], variant !== 'icon' && sizes[size], className)} {...props} data-id="element-1053" />;
}